import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-duas-azkar',
  imports: [PagePlaceholderComponent],
  templateUrl: './duas-azkar.component.html',
  styleUrl: './duas-azkar.component.scss'
})
export class DuasAzkarComponent {
  protected readonly icon = '📿';
  protected readonly pageTitle = 'pages.duas_azkar.title';
  protected readonly subtitle = 'pages.duas_azkar.subtitle';
}
